import type { SVGProps } from 'react';

const SvgRelations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 15c0 .55.45 1 1 1s1-.45 1-1v-2h4c.55 0 1 .45 1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-1.65-1.35-3-3-3h-4V9c0-.55-.45-1-1-1s-1 .45-1 1v2H7c-1.65 0-3 1.35-3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55.45-1 1-1h4zm-6 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4m14 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-7 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);
export default SvgRelations;
